var lineClamp = function lineClamp() {
  var lines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  return {
    display: "-webkit-box",
    WebkitLineClamp: lines,
    WebkitBoxOrient: "vertical",
    wordBreak: "break-word",
    overflow: "hidden"
  };
};
var hFlex = {
  d: "flex"
};
var vFlex = {
  d: "flex",
  flexDirection: "column"
};
var centerFlexChildren = {
  alignItems: "center",
  justifyContent: "center"
};
var padding = function padding(value) {
  return {
    p: "base.spacing.x".concat(value)
  };
};
var margin = function margin(value) {
  return {
    m: "base.spacing.x".concat(value)
  };
};

export { centerFlexChildren, hFlex, lineClamp, margin, padding, vFlex };
//# sourceMappingURL=sxChunks.js.map
